import { ViewDropdownMenu } from './dropdown-menu';

export * from './dropdown-menu';

export function effects() {
  customElements.define('hive-view-dropdown-menu', ViewDropdownMenu);
}
